import React from "react";
import CertificateDesigner from "./CertificateDesigner";

function CertificatePrintTab() {
  return <CertificateDesigner />;
}

export default CertificatePrintTab;
